import React from 'react';

import validate from '@vlabs/shared/validators';
import {
  Control, Margin, Grid, GridRow, GridCol,
} from '@vlabs/uikit';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './CreateHandlerForm.module.sass';

interface BiometricIdentificationFormProps {
  listOptions?: {
    label: string;
    value: string;
  }[];
  onSubmit: (values: unknown) => void;
}
function BiometricIdentificationForm({
  listOptions = [],
  onSubmit,
}: BiometricIdentificationFormProps): React.JSX.Element {
  const { t } = useTranslation();
  const {
    register, control, handleSubmit, formState: { errors },
  } = useForm();

  return (
    <form
      data-testid="modal.biometricIdentification"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Grid>
        <GridRow>
          <GridCol>
            <Margin display="block">
              <span className={st.Description}>
                {t('handlers:сценарий "Биометрическая идентификация лиц без сохранения в список" позволяет обнаружить все лица на кадре и сравнить их со всеми лицами в указанном списке.')}
              </span>
            </Margin>
            <Margin display="block">
              <div className="Body-2">{t('handlers:форма.наименование сценария')}</div>
              <Control.Input
                {...register('description', {
                  maxLength: validate.maxLength(128),
                  required: validate.required(),
                })}
                errors={errors}
              />
            </Margin>
            <Margin display="block">
              <div className="Body-2">
                {t('handlers:список для поиска')}
              </div>
              <Control.Select
                control={control}
                errors={errors}
                id="listId"
                name="listId"
                options={listOptions}
                rules={{ required: validate.required() }}
              />
            </Margin>
          </GridCol>
        </GridRow>
      </Grid>
      <Margin display="block">
        <Control.Button
          fullWidth
          type="submit"
        >
          {t('handlers:создать')}
        </Control.Button>
      </Margin>
    </form>
  );
}

export default BiometricIdentificationForm;
